import { useAuth } from 'reactfire';
import { useState } from 'react';
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Button,
  Box,
  Stack,
  Container,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import DeleteAccountDialog from './DeleteAccountDialog';

const Account = () => {
  const { currentUser } = useAuth();

  const [deleteAccountDialogOpen, setDeleteAccountDialogOpen] = useState(false);

  const handleDeleteAccountDialogOpen = () => {
    setDeleteAccountDialogOpen(true);
  };

  const handleDeleteAccountDialogClose = () => {
    setDeleteAccountDialogOpen(false);
  };

  return (
    <Container maxWidth="sm">
      <Stack flexDirection="row" alignItems="center">
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <AccountCircleIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={currentUser?.email}
            secondary="Обліковий запис"
          />
        </ListItem>
        <Box>
          <Button color="error" onClick={handleDeleteAccountDialogOpen}>
            Видалити
          </Button>
        </Box>
        <DeleteAccountDialog
          open={deleteAccountDialogOpen}
          onClose={handleDeleteAccountDialogClose}
        />
      </Stack>
    </Container>
  );
};

export default Account;
